import $ from "jquery";

// コンテンツバンク(文化庁)の動画を含む注文でのみ、利用規約のチェックに応じて
// 「注文を確定する」ボタンの有効・無効を切り替える。
// チェックボックスが無い注文ではサーバ側でボタンが有効になっているため、何もしない。
//
// 以前は「初期状態の反映」→「チェックボックスへの click ハンドラの直接バインド」の順だったため、
// スクリプトが実行されるより先にチェックされるとそのイベントを取りこぼし、
// ボタンが無効のまま決済できなくなることがあった。
// document への委譲 + change の監視にして、操作とスクリプト読み込みの順序に依存しないようにしている。
function syncSubmitState() {
  const policyCheckbox = $(".js-policy-checkbox");
  if (policyCheckbox.length === 0) return;

  $(".js-submit-purchase").prop("disabled", !policyCheckbox.prop("checked"));
}

syncSubmitState();

$(document).on("change", ".js-policy-checkbox", syncSubmitState);
